import { Component } from '@angular/core';

@Component({
	selector: 'app-automated-insights',
	templateUrl: './automated-insights.component.html',
})
export class AutomatedInsightsComponent {

}
